import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';

export interface Move {
  row: number,
  col: number,
  color: string,
}

let stompClient: Client;

export interface SubscriptionAction {
  moveTopic: (msg: any) => void,
  disconnectTopic: () => void,
};

/**
 * Establishes a WebSocket connection with the Spring backend.
 * Subscribes to "/topic/board" and invokes the provided callback
 * whenever a message is received from the server.
 *
 * @param onMessage - Function to call with the parsed message from the server
 */
export function connect(subscriptionAction: SubscriptionAction) {
  console.log("connect called");
  stompClient = new Client({
    webSocketFactory: () => new SockJS('http://localhost:8080/ws'),
    onConnect: () => {
      stompClient.subscribe('/topic/move', (message) => {
        const body = JSON.parse(message.body);
        subscriptionAction.moveTopic(body);
      });
      stompClient.subscribe('/topic/disconnect', (message) => {
        subscriptionAction.disconnectTopic();
      });
    }
  });

  console.log(">Activate client");
  stompClient.activate();
}

/**
 * Sends a player's move to the backend via STOMP over WebSocket.
 * The backend will broadcast it to other players via "/topic/board".
 *
 * @param move - Object containing row, column, and color of the move
 */
export function sendMove(move: Move) {
  if (stompClient && stompClient.connected) {
    stompClient.publish({
      destination: '/topic/move',
      body: JSON.stringify(move),
    });
  }
}
